export default __webpack_public_path__ + "static/media/shirt3.8ba36bb5.jpeg";